import { ApiClientCore } from './http/core';

export class AiApi extends ApiClientCore {
  async getAiBootstrap(): Promise<{
    available: boolean;
    eligible: boolean;
    daily_limit: number;
    context_days: number;
  }> {
    return this.get('/api/v1/ai/bootstrap');
  }

  async listAiConversations(): Promise<any[]> {
    return this.get('/api/v1/ai/conversations');
  }

  async createAiConversation(title?: string): Promise<any> {
    return this.post('/api/v1/ai/conversations', { title: title ?? null });
  }

  async listAiMessages(conversationId: number): Promise<any[]> {
    return this.get(`/api/v1/ai/conversations/${conversationId}/messages`);
  }

  async sendAiChat(message: string, conversationId?: number | null): Promise<any> {
    return this.post('/api/v1/ai/chat', {
      message,
      conversation_id: conversationId ?? null,
    });
  }

  async sendAiMessageFeedback(
    messageId: number,
    rating: 1 | -1,
    comment?: string | null
  ): Promise<any> {
    return this.post(`/api/v1/ai/messages/${messageId}/feedback`, {
      rating,
      comment: comment ?? null,
    });
  }

  async listAiInsights(params?: {
    insight_type?: string;
    unread_only?: boolean;
    limit?: number;
  }): Promise<any[]> {
    const q = new URLSearchParams();
    if (params?.insight_type) q.set('insight_type', params.insight_type);
    if (params?.unread_only) q.set('unread_only', 'true');
    if (params?.limit) q.set('limit', String(params.limit));
    const suffix = q.toString() ? `?${q.toString()}` : '';
    return this.get(`/api/v1/ai/insights${suffix}`);
  }

  async markAiInsightRead(insightId: number): Promise<any> {
    return this.post(`/api/v1/ai/insights/${insightId}/read`, {});
  }

  async generateAiMorningBrief(opts?: { force?: boolean; notify?: boolean }): Promise<any> {
    return this.post('/api/v1/ai/briefs/morning', {
      force: Boolean(opts?.force),
      notify: Boolean(opts?.notify),
    });
  }
}
